import React from "react";
import "./Footer.css";
import { Fade } from "react-awesome-reveal";
import { greeting } from "../../../portfolio";
import {ThemeProps} from "../../styles/themeprops";
import ToggleSwitch from "./ToggleSwitch";
import { useTranslation } from "react-i18next";
/* eslint-disable jsx-a11y/accessible-emoji */

type PageFooterProps = {
  children: React.ReactNode;
  theme:ThemeProps;
};
const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    //ßconst button: HTMLAnchorElement = event.currentTarget;
    window.print();
};

export default function Footer({children,
  theme,
}: PageFooterProps) {
	const { t, i18n } = useTranslation();
	const currentYear = new Date().getFullYear();
  return (
    <div className="footer-div">
    	<div className="main">
	    	<div id="navFunctionsWrapper" className="row collapse">
	      	<div className="col-1">
	         	<a href="#" title="Seite drucken (öffnet Dialog)" onClick={clickHandler}>drucken</a>
	         </div>
	         <div className="col-1">
	         	<a href="#" aria-haspopup="true" aria-owns="share" title="Mehr anzeigen" className="">empfehlen</a>
	         </div>
	      </div>
      	
      	
      	<div className="row footer-contact">
				  <div className="col-sm-6">
				      <h3>ViBeRu</h3>
				      <p></p>
				      <p className="c-contact-footer__address">
				        Querstr. 10<br/>
				        61194 Niddatal Ilbenstadt
				      </p>
				      <p>
				        <a href="tel:+49 231 5599-00"><span>+49 ‭176 23232948‬</span></a>&#160;
				        <i className="fa-solid fa-phone" style={{color: '#f8feff'}}></i>
				     </p>
				      <p>
				        <a href="mailto:info@viberu.de"><span>info@ViBeRu.de</span></a>&#160;
				        <i className="fa-solid fa-envelope" style={{color: '#f8feff'}}></i>
				     </p>
				      <p>
				        Bewerbungen unter: &#160;
				        <a href="mailto:bewerbung@viberu.de"><span>info@ViBeRu.de</span></a>&#160;
				        <i className="fa-solid fa-envelope" style={{color: '#f8feff'}}></i>
				     </p>
				  </div>
				  
			  	<div className="col-sm-6">
			      <div className="footer-social float-end">
			        {/*<div className="">
			          <h3 className="text-center">We are social</h3>
			          <div className="row">
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Twitter-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://twitter.com/Viberu_gmbh" rel="nofollow noreferrer">
									      <i className="fab fa-twitter fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Facebook-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.facebook.com/Viberu_gmbh" rel="nofollow noreferrer">
									      <i className="fab fa-facebook fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum  Blog von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="http://blog.viberu.de" rel="noreferrer">
									      <i className="fa fa-rss fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum XING-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.xing.com/companies/ViBeRu-gmbh" rel="nofollow noreferrer">
									      <i className="fab fa-xing fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Youtube-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.youtube.com/c/ViBeRu-gmbh" rel="nofollow noreferrer">
									      <i className="fab fa-youtube fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum LinkedIn-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.linkedin.com/company/ViBeRu-gmbh/" rel="nofollow noreferrer">
									      <i className="fab fa-linkedin fa-2x"></i>
									    </a>
									 </div>
									 <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Instagram-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.instagram.com/ViBeRuGmbH" rel="nofollow noreferrer">
									      <i className="fab fa-instagram fa-2x"></i>
									    </a>
									 </div>
									 <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Anchor-Kanal von ViBeRu (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://anchor.fm/ViBeRuGmbH" rel="nofollow noreferrer">
									      <i className="fab fa-spotify fa-2x"></i>
									    </a>
									 </div>
			          </div>
			       </div>
						 */
						 }
			     </div>
			  </div>
			</div>
			
			<div className="footer-links">
			  <div className="row d-flex">
			    <div className="col-lg-2">
			      <div className="tabs-container">
			      	<input className="menu-btn" type="checkbox" id="menu-btn-port" />
			        <label className="menu-icon" htmlFor="menu-btn-port">
			          <span className="">Portfolio</span>
			        </label>
			        <h3 className="menu-icon-link">
			          <a href="https://www.ViBeRu.de/Portfolio/portfolio.html" 
			          	data-bs-toggle="collapse" data-bs-target="#multiCollapseExample2" aria-expanded="false" aria-controls="multiCollapseExample2">Portfolio</a>
			        </h3>
			        <ul className="menu">
			          <li className="list-group-item d-flex justify-content-between align-items-center"><a href="/portfolio/technologien.html" title="Technologien">Tech­no­lo­gi­en</a></li>
			          <li className="list-group-item d-flex justify-content-between align-items-center"><a href="/portfolio/branchen.html" title="Branchen">Bran­chen</a></li>
			        </ul>
			      </div>
			    </div>
			    <div className="col-lg-2">
			      <div className="tabs-container">
			      	<input className="menu-btn" type="checkbox" id="menu-btn-unt" />
			        <label className="menu-icon" htmlFor="menu-btn-unt">
			          <span className="">Unternehmen</span>
			        </label>
			        <h3 className="menu-icon-link">
			          <a href="/Unternehmen/index.html">Unternehmen</a>
			        </h3>
			        <ul className="menu">
			          <li><a href="/Unternehmen/standorte.html">Un­se­re Stand­orte</a></li>
			          <li><a href="/Unternehmen/forschung-und-entwicklung.html">For­schung und Ent­wick­lung</a></li>
			        </ul>
			      </div>
			    </div>
			    <div className="col-lg-2">
			      <div className="tabs-container">
			      	<input className="menu-btn" type="checkbox" id="menu-btn-ref" />
			        <label className="menu-icon" htmlFor="menu-btn-ref">
			          <span className="">Referenzen</span>
			        </label>
			        <h3 className="menu-icon-link">
			          <a href="/Referenzen/index.html">Referenzen</a>
			        </h3>
			        <ul className="menu">
			          <li><a href="/Referenzen/index.html">Dahinter steckt ViBeRu</a></li>
			        </ul>
			      </div>
			    </div>
			    <div className="col-lg-2">
			      <div className="tabs-container">
			      	<input className="menu-btn" type="checkbox" id="menu-btn-carr" />
			        <label className="menu-icon" htmlFor="menu-btn-carr">
			          <span className="">Karriere</span>
			        </label>
			        <h3 className="menu-icon-link">
			          <a href="/Karriere/index.html">Karriere</a>
			        </h3>
			        <ul className="menu">
			          <li className="gsb-nav-nomenu"><a href="/Karriere/viberu-als-arbeitgeber" title="Das erwartet dich bei ViBeRu">Das er­war­tet dich</a></li>
			          <li><a href="/Karriere/einstiegsmoeglichkeiten" title="Dein Einstieg bei ViBeRu">Dein Ein­stieg</a></li>
			          <li><a href="/Karriere/rund-ums-bewerben" title="Deine Bewerbung bei ViBeRu">Dei­ne Be­wer­bung</a></li>
			        </ul>
			      </div>
			    </div>
			    <div className="col-lg-2">
			      <div className="tabs-container">
			      	<input className="menu-btn" type="checkbox" id="menu-btn-carr" />
			        <label className="menu-icon" htmlFor="menu-btn-carr">
			          <span className="">Service</span>
			        </label>
			        <h3 className="menu-icon-link">Service</h3>
			        <ul className="menu">
			          <li><a href="/contact">Kon­takt</a></li>
			        </ul>
			      </div>
			    </div>
			  </div>
			
			  <div className="row footer-links-static">
			    <div className="col">
			      <ul>
			        <li><a href="/Service/impressum" title="Impressum &amp; Copyright">Im­pres­s­um &amp; Co­py­right</a></li>
			        <li><a href="/Service/privacy" title="Datenschutzerklärung">Da­ten­schut­z­er­klä­rung</a></li>
			        <li><a href="/Service/privacy-kunde" title="Datenschutzinformationen für Kunden">Da­ten­schutz­in­for­ma­tio­nen für Kun­den</a></li>
			        <li><a href="/Service/accessibility" title="Erklärung zur Barrierefreiheit">Bar­rie­re­frei­heit</a></li>
			        <li><a href="/Service/cookie-policy" title="Cookie Policy">Cookie Policy</a></li>
			        <li><a href="/Service/sitemap" title="Sitemap">Si­te­map</a></li>
			      </ul>
			    </div>
			    <div className="column large-2 medium-5 c-footer__image"></div>
			  </div>
			</div>
						
	      <Fade>
		      <div className="copyright row">
		      	<div className="col">@ ViBeRu {currentYear}</div>
		      	<div className="col">
		      		<div className="float-end">
		          Made with <span role="img">❤️</span> by {t("site.title")}
		          </div>
		        </div>
		       </div>
		        {/* <ToggleSwitch theme={props.theme} onToggle={props.onToggle}/> */}
	      </Fade>
      </div>
    </div>
  );
}
